/* Shirts Frenzy — slide-down predictive search.
   Opens on the search icon, fetches live from /search/suggest.json. */
(function () {
  var root = document.getElementById('sf-search');
  if (!root) return;
  var input = root.querySelector('[data-sf-search-input]');
  var results = root.querySelector('[data-sf-results]');
  var suggest = root.querySelector('[data-sf-suggest]');
  var opener = null;
  var focusTimer;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function open(control) {
    opener = control;
    clearTimeout(focusTimer);
    root.inert = false;
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    focusTimer = setTimeout(function () { if (root.classList.contains('open')) input.focus(); }, 90);
  }
  function close() {
    clearTimeout(focusTimer);
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    root.classList.remove('open');
    root.inert = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function render(products, q) {
    if (!products.length) {
      results.innerHTML = '<div class="srch-empty mono">No drops match “' + esc(q) + '”.</div>';
      return;
    }
    results.innerHTML = products.map(function (p) {
      var src = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      if (src) src += (src.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
      var thumb = src ? '<img src="' + src + '" alt="" loading="lazy">' : '';
      return '<a class="srch-res" href="' + p.url + '">'
        + '<div class="pimg srch-thumb">' + thumb + '</div>'
        + '<span class="srch-res-name">' + esc(p.title) + '</span>'
        + '<span class="mono srch-res-col">' + esc(p.type || p.vendor || '') + '</span>'
        + '<span class="mono srch-res-price">$' + esc(p.price) + '</span></a>';
    }).join('');
  }

  // Collapse a design's Set members to ONE result. Every style variant of a
  // design is a separate product that shares the same TITLE ("Lunar Echo"),
  // differing only by handle suffix (master = "lunar-echo" = the Tall Tee;
  // members = "lunar-echo-tee-classic", …). Showing all 6 buried unique designs;
  // one card is enough — its PDP has the in-set style switcher. Keep one per
  // title, preferring the SHORTEST handle (the master / clean design page).
  function handleOf(p) {
    return ((p.url || '').split('/products/')[1] || '').split('?')[0];
  }
  function collapseSets(products) {
    var byTitle = {}, order = [];
    products.forEach(function (p) {
      var t = (p.title || '').trim().toLowerCase();
      if (!t) { order.push('#' + order.length); byTitle['#' + (order.length - 1)] = p; return; }
      if (!byTitle[t]) { byTitle[t] = p; order.push(t); }
      else if (handleOf(p).length < handleOf(byTitle[t]).length) { byTitle[t] = p; }
    });
    return order.map(function (k) { return byTitle[k]; });
  }

  var timer;
  function run(q) {
    q = (q || '').trim();
    if (!q) { suggest.hidden = false; results.hidden = true; results.innerHTML = ''; return; }
    suggest.hidden = true; results.hidden = false;
    // fetch the max (10) so that after collapsing a design's 6 style variants
    // there are still enough distinct designs to fill the dropdown.
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        render(collapseSets(ps).slice(0, 6), q);
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value;
      clearTimeout(timer);
      timer = setTimeout(function () { run(q); }, 200);
    });
  }

  document.addEventListener('click', function (e) {
    var control = e.target.closest('[data-sf-search-open]');
    if (control) { e.preventDefault(); open(control); return; }
    if (e.target.closest('[data-sf-search-close]')) { e.preventDefault(); close(); return; }
    var chip = e.target.closest('[data-sf-chip]');
    if (chip) { input.value = chip.textContent.trim(); run(input.value); input.focus(); }
  });
  // close on tap/click anywhere outside the panel (pointerdown is reliable on iOS)
  document.addEventListener('pointerdown', function (e) {
    if (!root.classList.contains('open')) return;
    if (e.target.closest('.srch-panel') || e.target.closest('[data-sf-search-open]')) return;
    close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('open')) close(); });
})();
